<template>
  <div>
    <el-dialog :visible.sync="linkProductVisible" class="orderDetailDialog" width="40%">
      <budget-detail :checkBudget="checkBudgetObj" :chooseStockTypes="[budgetItem.state]" @deleteProduct="deleteProduct" 
        :planProductShowStatus="true" :showCostPrice="true" :showShaft="1" :linkProductFlag="true"></budget-detail>
    </el-dialog>
  </div>
</template>

<script>
import budgetDetail from '../children/budgetDetail.vue'
import PlanApi from '@/components/Api/PlanApi.js'
export default {
  components: { budgetDetail },
  props:{
    checkBudget:{
      type:Object,
      default:()=>{return {}}
    },
  },
  data(){
    return{
      linkProductVisible:false, 
      checkBudgetObj:{},
      budgetItem:{}
    }
  },
  methods:{
    deleteProduct(){
      this.getLinkProductList()
    },
    getLinkProductList(){
      new PlanApi('plan').linkList({linkFlag:this.budgetItem.linkFlag}).then(res => {
        if (res.status == 200) {
          var planDays = []
          if(res.data.length==0) this.linkProductVisible=false
          this.checkBudget.planDayList.forEach(element => {
            var details = res.data.filter(ee=>ee.day==element.planDay)
            details.forEach(ee=>{
              var totalPrice=0
              var currency=''
              ee.details.forEach(detail=>{
                totalPrice = totalPrice+(detail.stockPrice*detail.stockNumber)
                currency = detail.currency
                var stockDetail = {}
                if(detail.stockDetail&&detail.stockDetail!=''){
                  stockDetail = JSON.parse(detail.stockDetail)
                }
                this.$set(detail,'stockDetail',stockDetail)
              })
              this.$set(ee,'totalPrice',totalPrice)
              this.$set(ee,'currency',currency)
              })      
            planDays.push({
              planDay:element.planDay,
              planDate:element.planDate,
              cityList:element.cityList,
              budgetDetails:details,
            })
          });
          this.checkBudgetObj={
            planId:this.checkBudget.planId,
            id:this.checkBudget.id,
            planDayList:planDays,
          }
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    beforOpen(item){
      this.linkProductVisible = true
      this.budgetItem = item
      this.getLinkProductList()
    }
  }
}
</script>

<style>

</style>